// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".update-button__modal__content{max-height:60vh;overflow-y:auto}", "",{"version":3,"sources":["webpack://./app/components/UpdateButton/style.scss"],"names":[],"mappings":"AAAA,+BACE,eAAA,CACA,eAAA","sourcesContent":[".update-button__modal__content {\r\n  max-height: 60vh;\r\n  overflow-y: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
